import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@app/core/services/toast/toast.service';
import { BaseDialogFormViewDirective } from '@app/shared/base-views/base-dialog-form-view.directive';
import { Observable } from 'rxjs';
import moment from 'moment';
import { BuildingConsentMappedItem, IResourceConsentMappedItem, IBuildingConsentMappedItem } from '@app/logic/lot-consents';

interface IData {
    mappedItem: any;
}

@Component({
    selector: 'cb-edit-consent-details-dialog',
    templateUrl: './edit-consent-details-dialog.component.html',
    styleUrls: ['./edit-consent-details-dialog.component.scss'],
    standalone: false
})
export class EditConsentDetailsDialogComponent extends BaseDialogFormViewDirective<any, any, any> {
    public static readonly MIN_WIDTH = '33%';
    public get mappedItem(): IResourceConsentMappedItem | IBuildingConsentMappedItem {
        return this.data.mappedItem;
    }
    public get buildingConsent(): IBuildingConsentMappedItem {
        return this.data.mappedItem as IBuildingConsentMappedItem;
    }

    public readonly isBuildingConsent = this.mappedItem instanceof BuildingConsentMappedItem;

    private _minExpiryDateSource: string;
    private _minExpiryDate: Date | null = null;

    /** Expiry dates must be strictly after the Consent Granted date */
    public get minExpiryDate(): Date | null {
        const granted = this.mappedItem.consentGrantedDate;
        if (granted !== this._minExpiryDateSource) {
            this._minExpiryDateSource = granted;
            this._minExpiryDate = granted ? moment(granted).add(1, 'day').startOf('day').toDate() : null;
        }
        return this._minExpiryDate;
    }

    public isNotAfterGrantedDate(date: string | Date): boolean {
        if (!date || !this.minExpiryDate) {
            return false;
        }
        return moment(date).isBefore(this.minExpiryDate, 'day');
    }

    public get hasInvalidExpiryDates(): boolean {
        return this.isNotAfterGrantedDate(this.mappedItem.consentExpiryDate)
            || (this.isBuildingConsent && this.isNotAfterGrantedDate(this.buildingConsent.codeOfComplianceExpiryDate));
    }

    constructor(
        public readonly dialogRef: MatDialogRef<EditConsentDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        @Inject(ToastService) public readonly toastService: ToastService,
    ) {
        super(dialogRef, toastService);
    }

    public saveMethod(): Observable<any> {
        return this.mappedItem.$save();
    }
}
